import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

export const ordersDepricatedRouteRedirect: CanActivateFn = (route) => {
  const router = inject(Router);
  const orderId = route.queryParamMap.get('orderId');
  const orderItemId = route.queryParamMap.get('orderItemPosition');
  if (orderId && orderItemId) {
    return router.createUrlTree(['/orders', orderId, 'items', orderItemId]);
  }
  return true;
};

export const prDepricatedRouteRedirect: CanActivateFn = (route) => {
  const router = inject(Router);
  const orderId = route.queryParamMap.get('orderId');
  const orderItemId = route.queryParamMap.get('orderItemPosition');
  const orderItemConfigurationId = route.queryParamMap.get('configId');
  const download = route.queryParamMap.get('download') ?? 'false';
  if (orderId && orderItemId && orderItemConfigurationId) {
    return router.createUrlTree(
      [
        '/orders',
        orderId,
        'items',
        orderItemId,
        'configurations',
        orderItemConfigurationId,
        'production-record',
      ],
      {
        queryParams: { download },
      },
    );
  }
  return true;
};
